export enum AuthorType {
  AI = 'AI',
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

export type MessageMetadata = Record<string, any>[];
export type ResponseType = 'text' | 'option';

export type ChatDynamicParams = {
  requestBody?: Record<string, any>;
  pathParameters?: Record<string, any>;
  queryParameters?: Record<string, any>;
};
export type APIMessage = {
  author_type: AuthorType;
  content: string;
  options?: string[]; //TODO: Integrar sistema opciones en innovachat
  metadata?: MessageMetadata;
};
export type Message = {
  authorType: AuthorType;
  content: string;
  options?: string[]; //TODO: Integrar sistema opciones en innovachat
  metadata?: MessageMetadata;
  responseType?: ResponseType;
};

type AiReport = {
  data: string;
  description: string;
  type: 'report';
};

export type AiArtifact = {
  [key: string]: AiReport;
};

export function mapApiMessageToMessage(message: APIMessage): Message {
  return {
    authorType: message.author_type,
    content: message.content,
    options: message.options,
    metadata: message.metadata,
  };
}

export function mapMessageToApiMessage(message: Message): APIMessage {
  return {
    author_type: message.authorType,
    content: message.content,
    options: message.options,
    metadata: message.metadata,
  };
}
